import { render, staticRenderFns } from "./InputRectSize.vue?vue&type=template&id=69575ce0&scoped=true&"
import script from "./InputRectSize.vue?vue&type=script&lang=js&"
export * from "./InputRectSize.vue?vue&type=script&lang=js&"
import style0 from "./InputRectSize.vue?vue&type=style&index=0&id=69575ce0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69575ce0",
  null
  
)

export default component.exports